module.exports = __webpack_public_path__ + "img/focus-xcx.c4d564f5.png";